import './App.css';
import React from 'react';
import Header from './shared/header/Header';
import Characters from './characters/Characters';

function App() {
  return (
    <>
      <Header></Header>
      <Characters></Characters>
    </>
  );
}

export default App;
